import React, { Fragment } from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
const categories = [{
  label: 'Injectables',
  id: 'injectables'
}, {
  label: 'Lasers',
  id: 'lasers'
}, {
  label: 'Body',
  id: 'body'
}, {
  label: 'Skin',
  id: 'skin'
}, {
  label: 'Medical',
  id: 'medical'
}];
export function TreatmentsHero() {
  const handleClick = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-black pt-[180px] pb-[60px] lg:pt-[200px] lg:pb-[100px] relative overflow-hidden" data-id="element-2198">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8 relative z-10" data-id="element-2199">
        <AnimateOnScroll className="flex flex-col items-center text-center" data-id="element-2200">
          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-6 font-[Poppins,_sans-serif]" data-id="element-2201">
            TREATMENTS
          </span>

          <h1 className="text-[32px] sm:text-5xl md:text-6xl lg:text-[64px] uppercase text-white tracking-tight mb-6 font-[600] font-[Poppins,_sans-serif] leading-none" data-id="element-2202">
            OUR TREATMENTS
          </h1>

          <p className="font-serif italic text-[17px] lg:text-[22px] text-white/85 leading-[1.6] mb-8 max-w-[650px] mx-auto" data-id="element-2203">
            Experience personalization at its finest with our selection of
            aesthetic and medical treatments.
          </p>

          <div className="w-[60px] h-[2px] bg-[#FF1493] mx-auto mb-8" data-id="element-2204"></div>

          {/* Quick-jump navigation */}
          <div className="flex flex-wrap justify-center gap-x-2 gap-y-3" data-id="element-2205">
            {categories.map((cat, i) => <Fragment key={cat.id} data-id="element-2206">
                <button onClick={() => handleClick(cat.id)} className="text-white uppercase text-[13px] font-bold tracking-widest hover:text-[#FF1493] transition-colors font-[Poppins,_sans-serif] min-h-[44px] px-3" data-id="element-2207">
                  {cat.label}
                </button>
                {i < categories.length - 1 && <span className="text-white/30 self-center hidden sm:inline" data-id="element-2208">
                    |
                  </span>}
              </Fragment>)}
          </div>
        </AnimateOnScroll>
      </div>
    </section>;
}